import {ItemChip} from 'interface/base/ItemChip';
import {Tooltip} from 'interface/base/Tooltip';
import {Image, Pressable, StyleSheet} from 'react-native';

// @ts-ignore
import imageAiIcon from 'assets/images/storage/ai-icon.png';
import type {FilesItem} from 'store/slices/files/types';

interface ItemAiProcessingProps {
  tip: 'top' | 'left';
  state: FilesItem['ai']['state'];
}

export function ItemAiProcessing({tip, state}: ItemAiProcessingProps) {
  let label = '';
  let tooltip = '';
  switch (state) {
    case 'pending':
      label = 'Pending';
      tooltip =
        'Processing this file to enable AI features. It will be available shortly.';
      break;
    case 'in_progress':
      label = 'Processing';
      tooltip =
        'Processing this file to enable AI features. It will be available shortly.';
      break;
    case 'ready':
      label = 'Ready';
      tooltip = 'AI features are ready to use.';
      break;
    case 'failed':
      label = 'Failed';
      tooltip = 'Failed to process this file.';
      break;
    case 'disabled':
      label = 'Disabled';
      tooltip = 'AI features are disabled for this file.';
      break;
    default:
      state satisfies never;
  }
  return (
    <Tooltip
      placement={tip === 'left' ? 'left' : 'top'}
      content={tooltip}
      showArrow>
      <Pressable style={styles.root}>
        <ItemChip
          startEnhancer={
            <Image
              source={imageAiIcon}
              style={{width: 16, height: 16, margin: 2}}
            />
          }
          label={label}
          padding={{
            left: false,
            right: true,
          }}
        />
      </Pressable>
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  root: {
    position: 'relative',
    cursor: 'default',
  },
});
